// extracted by mini-css-extract-plugin
export default {"welcome-section":"AmenitiesSection_welcome-section__WJYC-","welcome-section-text-content":"AmenitiesSection_welcome-section-text-content__4B0JM"};